import nBossConnection from "modules/base/service/nBossConnection";
import EntityValidationResult from "modules/base/dto/validation/EntityValidationResult";
import TrustNCGOptimizerEditDto from "../dto/TrustNCGOptimizerEditDto";

class TrustNCGOptimizerEditService {
    constructor() {
        this.connection = nBossConnection.connection;
        this.CONTROL = "trustNCGOptimizerEditControl";
    }

    /**
     * @return {Promise<TrustNCGOptimizerEditDto>}
     */
    create() {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then((response) =>
                    resolve(new TrustNCGOptimizerEditDto().setup(response.data))
                )
                .catch(reject);
        });
    }

    /**
     * @param {string} type
     * @return {Promise<TrustNCGOptimizerEditDto>}
     */
    createByType(type) {
        return new Promise((resolve, reject) => {
            this.connection
                .get(`/${this.CONTROL}/create`)
                .then((response) =>
                    resolve(
                        new TrustNCGOptimizerEditDto().setup({
                            ...response.data,
                            type,
                        })
                    )
                )
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @return {Promise<TrustNCGOptimizerEditDto>}
     */ 
    getData(id) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/getData`, {
                    id,
                })
                .then((response) =>
                    resolve(new TrustNCGOptimizerEditDto().setup(response.data))
                )
                .catch(reject);
        });
    }

    /**
     * @param {TrustNCGOptimizerEditDto} dto
     * @return {Promise<EntityValidationResult>}
     */
    save(dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/save`, {
                    dto,
                })
                .then((response) =>
                    resolve(new EntityValidationResult().setup(response.data))
                )
                .catch(reject);
        });
    }

    /**
     * @param {number} id
     * @param {TrustNCGOptimizerEditDto} dto
     * @return {Promise<EntityValidationResult>}
     */
    update(id, dto) {
        return new Promise((resolve, reject) => {
            this.connection
                .post(`/${this.CONTROL}/update`, {
                    id,
                    dto,
                })
                .then((response) =>
                    resolve(new EntityValidationResult().setup(response.data))
                )
                .catch(reject);
        });
    }
}

export default new TrustNCGOptimizerEditService();